import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';

/**
 * The current user's active plan subscription (concept #2:
 * user_subscriptions/subscription_plans — what custom apps gate access on).
 * Backed by `GET /user/subscription`. `can_manage` is true when a Stripe
 * billing portal is available for the subscription.
 */
export interface UserSubscription {
  id: string;
  status: string;
  current_period_start: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  can_manage: boolean;
  plan_slug: string | null;
  plan_name: string | null;
  plan_interval: string | null;
  plan_price: string | number | null;
}

export function useSubscription() {
  return useQuery({
    queryKey: ['user-subscription'],
    queryFn: () =>
      api.get<{ subscription: UserSubscription | null }>('/user/subscription'),
  });
}
